<template>
  <b-modal size="lg" v-model="showForm" :title="title" no-close-on-backdrop  no-enforce-focus>
    <div class="row">
      <div class="col-md" v-if="benhNhan">
        <div class="alert alert-info">
          <b>Họ và tên: </b> <span>{{ benhNhan.name ? benhNhan.name : 'Không rõ' }}</span><br/>
          <b>Năm sinh: </b> <span>{{ benhNhan.dob ? benhNhan.dob : 'Không rõ' }}</span><br/>
          <b>Ngày xét nghiệm: </b> <span>{{ benhNhan.testDate ? benhNhan.testDate : 'Không rõ' }}</span><br/>
          <b>CT Value: </b> <span>{{ benhNhan.ctValue ? benhNhan.ctValue : 'Không rõ' }}</span><br/>
          <b>Mức CT: </b> <span>{{ benhNhan.ctLevel ? benhNhan.ctLevel : 'Không rõ' }}</span><br/>
          <b>Giới tính: </b><span>{{ benhNhan.gender === 'unknown' ? 'Không rõ' : benhNhan.gender === 'male' ? 'Nam' : 'Nữ' }}</span><br/>
          <b>Lý do xét nghiệm: </b> <span>{{ benhNhan.testReason ? benhNhan.testReason : 'Không rõ' }}</span>
        </div>
        <h5>Chuyển từ {{benhNhan.tier}} sang {{benhNhan.nextTier}}</h5>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" class="float-right" @click="showForm = false"
      >{{ $t('cancel') }}
      </b-button>
      <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="changeNc">
        <b-spinner v-if="saveLoading" small></b-spinner>
        {{title}}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  data: function () {
    return {
      benhNhan: null,
      showForm: false,
      title: null,
      saveLoading: false,
      action: null
    }
  },
  methods: {
    open(benhNhan, action) {
      this.benhNhan = benhNhan;
      this.action = action;
      this.title = action === 'approve' ? 'Duyệt chuyển NC' : 'Từ chối chuyển NC';
      this.showForm = true;
    },
    changeNc() {
      this.saveLoading = true;
      this.$service.post('/benh-nhan/change-nc/' + this.benhNhan._id, {action: this.action}).then(response => {
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: 'Cập nhật thông tin thành công',
            icon: 'success',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
          this.$bus.$emit('reloadBenhNhanList');
        } else {
          this.$swal({
            title: this.$t('error'),
            text: 'Cập nhật thông tin thất bại',
            icon: 'error',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
        }
        this.showForm = false;
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showForm = false;
        }
      }).finally(() => {
        this.saveLoading = false;
      });
    }
  }
}
</script>

<style scoped>

</style>